import React, { Component } from "react";
import { Row, Col, Nav, NavLink, NavItem, TabContent, TabPane, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Input } from "reactstrap";
import classnames from 'classnames';

// Components
import HeaderContainer from "../Header/HeaderContainer";
import ResetPasswordModal from "./ResetPasswordModal";
import InitializeMfaModal from "./InitializeMfaModal";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import SessionDetails from "./ReportComponent/SessionDetails";
import { convertMinutesToDDhhmm } from "UTILS/DateUtils";
import { getAnnouncementMarquee } from "UTILS/Utility";

// Strings
import { getMessage } from "CONFIG/i18n";

// Styles
import "../Organisations/Organisations.less";
import "./AdminDashboard.less";
import UsersList from "./UserList";
import SessionList from "./ReportComponent/SessionList";
import SmsSentNumber from "./ReportComponent/SmsSentNumber";
import EncodingTime from "./ReportComponent/EncodingTime";
import UsageReport from "./ReportComponent/UsageReport";

// Actions
import { userAction } from "CONFIG/ActionFactory";
import { systemAnnouncementAction } from "CONFIG/ActionFactory";
import { BUSINESS_MODELS, TIMEOUT } from "../../../Utils/Constants";
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResetPasswordModalFlag: this.props.showResetPasswordModalFlag,
      showResetPasswordUsesIdModalFlag: this.props.showResetPasswordUsesIdModalFlag,
      showResetPasswordEmailModalFlag: false,
      resetPasswordUserData: {},
      showAboutOrgModalFlag: false,
      dropdownOpen: false,
      activeAnnouncements: null,
      searchKey: "",
      searchTimeout: null,
      showThresholdErrorToast: false,
      showInitializeMfaModalFlag: this.props.showInitializeMfaModalFlag
    };
  }

  componentDidMount() {
    if(this.state.showResetPasswordModalFlag) {
      this.setState({
        showResetPasswordEmailModalFlag: true
      });
    }
    this.setState({
      initializeMfaEmail: this.props.initializeMfaEmail
    })
    // get active announcements
    systemAnnouncementAction.getActiveAnnouncementsAction().then(
      (response) => {
        this.setState({
          activeAnnouncements: response.data
        });
      },
      error => {
        console.error(error);
      }
    )
  }

  componentDidUpdate(preProp) {
    if (
      preProp.showResetPasswordUsesIdModalFlag !==
      this.props.showResetPasswordUsesIdModalFlag
    ) {
      this.setState({
        showResetPasswordUsesIdModalFlag: this.props.showResetPasswordUsesIdModalFlag
      });
    }
    if (
      preProp.showResetPasswordModalFlag !==
      this.props.showResetPasswordModalFlag
    ) {
      this.setState({
        showResetPasswordModalFlag: this.props.showResetPasswordModalFlag
      });
    }
    if (
      preProp.showInitializeMfaModalFlag !==
      this.props.showInitializeMfaModalFlag
    ) {
      this.setState({
        showInitializeMfaModalFlag: this.props.showInitializeMfaModalFlag,
      });
    }
    if (
      preProp.showConfirmationModalFlag !== this.props.showConfirmationModalFlag
    ) {
      this.setState({
        showConfirmationModalFlag: this.props.showConfirmationModalFlag
      });
    }
    if (!this.state.showThresholdErrorToast &&
       ((this.props.customerStatistics.concurrentSessionThreshold && this.props.customerStatistics.concurrentSessionThreshold > 0) && this.props.customerStatistics.activeSessions >= this.props.customerStatistics.concurrentSessionThreshold) && 
      BUSINESS_MODELS.MAX_CONCURRENT_CONNECTIONS == this.props.customerStatistics.businessModel) {
      this.setState({showThresholdErrorToast: true});
      toastr.error(getMessage("THRESHOLD_VALUE_EXCEEDS"));
    }
  }

  showQRPopUp = () => {

  }

  toggleDropdown = () => {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  setTabs = (event) => {
    userAction.saveCurrentActiveTab(event.target.id);
    this.setState({ searchKey: "" });

    // Call method to clear data and display search box on click of tabs
    this.props.onBackClick();

    // Fetch records on tab change
    if (event.target.id == "2") {
      this.props.fetchSessionsList();
    } else if (event.target.id == "3") {
      this.props.smsSendNumber();
    } else if (event.target.id == "4") {
      this.props.encodingTime();
    } else {
      this.props.getAllUserData(0, this.props.userListPageSize);
    }
  }

  search = (event) => {
    const searchData = event.target.value;
    if (this.state.searchTimeout) {
      clearTimeout(this.state.searchTimeout);
    }
    if (this.state.searchKey !== searchData) {
      this.setState({
        searchKey: searchData,
        searchTimeout: setTimeout(() => {
          this.props.currentActiveTab === '2' && !this.props.sessionDetails && !this.props.sessionKey ?
            this.props.fetchSessionsList(0, this.props.sessionListPageSize, searchData) :
            this.props.getAllUserData(0, this.props.userListPageSize, searchData)
        }, 1000)
      });
    }
  }

  resetValuesOnAddUser = () => {
    this.setState({
      searchKey: ""
    });
    // Show Users tab as selected
    userAction.saveCurrentActiveTab("1");
  }

  render() {
    //console.log("inside AdminDashboard showModal",this.props.showAddUserModal)
    //console.log("inside AdminDashboard showModal",this.props.showBulkUserUploadModal)
    let isThresholdReached = ((this.props.customerStatistics.concurrentSessionThreshold && this.props.customerStatistics.concurrentSessionThreshold > 0) && this.props.customerStatistics.activeSessions >= this.props.customerStatistics.concurrentSessionThreshold) ? true : false;
    let isBusinessModelIsMaxConcurrentConn = (BUSINESS_MODELS.MAX_CONCURRENT_CONNECTIONS == this.props.customerStatistics.businessModel) ? true : false;
   
    return (
      <div>
        <HeaderContainer
          title={this.props.organisationName}
          headerButtonText={getMessage("ADD_USER")}
          showAddUserModal={this.props.showAddUserModal}
          showBulkImportUserModal={this.props.showBulkUserUploadModal}
          showAddUserDropdown={this.props.showAddUserDropdown}
          history={this.props.history}
          showAboutOrgModal={this.props.showAboutOrgModal}
          getAllUserData={this.props.getAllUserData}
          logoUrl={this.props.logoUrl}
          showQRPopUp={this.props.showQRPopUp}
          isAdmin={true}
          showQR={this.props.showQR}
          isDashboard={true}
        />
        {this.state.activeAnnouncements && this.state.activeAnnouncements.length >= 1 &&
          <marquee>
            <label className="announcementLabel">
              {getAnnouncementMarquee(this.state.activeAnnouncements)}
            </label>
          </marquee>
        }
        <Row className={this.state.activeAnnouncements && this.state.activeAnnouncements.length >= 1
          ? "organisationHeader mt-0"
          : "organisationHeader"}>
          <Col lg={2} className="setHeaderMargin">
            <label className="summaryValue nameEllipsis">{this.props.customerStatistics.totalAgents}</label>
            <label className="summaryLabel">{getMessage("NUMBER_OF_AGENTS")}</label>
          </Col>
          <Col lg={2} className="setHeaderMargin">
            <label className="summaryValue nameEllipsis">{this.props.customerStatistics.totalSessions}</label>
            <label className="summaryLabel">{getMessage("NUMBER_OF_TOTAL_SESSIONS")}</label>
          </Col>
          {isBusinessModelIsMaxConcurrentConn ? <Col lg={2} className="setHeaderMargin" title={isThresholdReached ? getMessage("THRESHOLD_VALUE_EXCEEDS") : ""} data-toggle='tooltip'>
            <label className={isThresholdReached ? "summaryValue nameEllipsis maxConcurrentDataLabel" : "summaryValue nameEllipsis"}>{this.props.customerStatistics.activeSessions + ' / ' + this.props.customerStatistics.maxConcurrentSessions}</label>
            <label className={isThresholdReached ? "summaryLabel maxConcurrentDataLabel" : "summaryLabel"}>{getMessage("NUMBER_OF_ACTIVE_SESSIONS") + ' / ' + getMessage("MAX_CONCURRENT_CONNECTIONS")}</label>
          </Col> :
            <Col lg={2} className="setHeaderMargin">
              <label className="summaryValue nameEllipsis">{this.props.customerStatistics.activeSessions}</label>
              <label className="summaryLabel">{getMessage("NUMBER_OF_ACTIVE_SESSIONS")}</label>
            </Col>}

          <Col lg={2} className="setHeaderMargin">
            <label className="summaryValue nameEllipsis">{convertMinutesToDDhhmm(this.props.customerStatistics.totalTimeToDate)}</label>
            <label className="summaryLabel">{getMessage("TOTAL_USAGE_TO_DATE")}</label>
          </Col>
        </Row>
        <div className="userList">
          <ResetPasswordModal
            userData={this.state.resetPasswordUserData}
            show={this.state.showResetPasswordModalFlag ? true : this.state.showResetPasswordUsesIdModalFlag}
            showPasswordUsesIdFlag={this.state.showResetPasswordUsesIdModalFlag}
            resetPasswordEmail={this.props.resetPasswordEmail}
            handleCancelClick={this.props.handleCancelClick}
            handleResetPassword={this.props.handleResetPassword}
            setPasswordTarget={this.props.setPasswordTarget}
          />
          <InitializeMfaModal
            userData={this.state.initializeMfaUserData}
            show={this.state.showInitializeMfaModalFlag}
            handleCancelClick={this.props.handleCancelClick}
            handleInitializeClick={this.props.handleInitializeClick}
            initializeMfaEmail={this.props.initializeMfaEmail}
          />
          {/* <AboutOrganisationModal
            show={this.state.showAboutOrgModalFlag}
            handleCancelClick={this.handleCancelAboutOrgModal}
            handleSaveClick={this.handleSaveClick}
            organizationData ={this.state.organizationData}
          /> */}
          <DeleteConfirmationModal
            data={this.state.resetPasswordUserData}
            show={this.state.showConfirmationModalFlag}
            deleteTarget={this.props.deleteTarget}
            handleCancelClick={this.props.handleCancelClick}
            handleDeleteClick={this.props.handleDeleteUserClick}
            isDeleteOrganization={false}
          />

          <Row className="navTabMargin navTabBackground">
            <Col className="noPadding">
              <Nav tabs className="navTab">
                <NavItem>
                  <NavLink
                    id='1'
                    onClick={this.setTabs}
                    className={(this.props.currentActiveTab === '1') ? "otherActiveTabs agentTab" : "otherTabs agentTab"}
                  >
                    {getMessage("USERS")}
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink>
                    <Dropdown className="reportsDropdownTab" group isOpen={this.state.dropdownOpen} size="sm" toggle={this.toggleDropdown}>
                      <DropdownToggle caret className={(this.props.currentActiveTab === '2' || this.props.currentActiveTab === '3') ? "reportsDropdownTab" : "reportsDropdownActiveTab"}>
                        {getMessage("REPORTS")}
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem
                          className={classnames({ active: this.props.currentActiveTab === '2' })}
                          id='2'
                          onClick={this.setTabs}
                        >
                          {getMessage("SESSION_LIST")}
                        </DropdownItem>
                        <DropdownItem
                          className={classnames({ active: this.props.currentActiveTab === '3' })}
                          id='3'
                          onClick={this.setTabs}
                        >
                          {getMessage("NUMBER_OF_SMS_SENT")}
                        </DropdownItem>
                        <DropdownItem
                          className={classnames({ active: this.props.currentActiveTab === '4' })}
                          id='4'
                          onClick={this.setTabs}
                        >
                          {getMessage("ENCODING_TIME")}
                        </DropdownItem>
                        <DropdownItem
                          className={classnames({ active: this.props.currentActiveTab === '5' })}
                          id='5'
                          onClick={this.setTabs}
                        >
                          {getMessage("USAGE_REPORT")}
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col md={3}>
              {(!this.props.sessionDetails && !this.props.sessionKey) && (this.props.currentActiveTab !== '3' && this.props.currentActiveTab !== '4') ?
                <Input
                  className=""
                  value={this.state.searchKey}
                  placeholder={getMessage("SEARCH")}
                  onChange={this.search}
                />
                :
                <Input
                  disabled
                  className=""
                  value={this.state.searchKey}
                  placeholder={getMessage("SEARCH")}
                />
              }  
            </Col>

          </Row>
          {this.props.showTable &&
            <TabContent activeTab={this.props.currentActiveTab}>
              <TabPane tabId="1">
                <Row className="noMargin">
                  <Col sm="12" className="noPadding">
                    <div>
                      {this.props.currentActiveTab === "1" ?
                        <UsersList
                          showEditUserModal={this.props.showEditUserModal}
                          showDeleteConfirmationModal={this.props.showDeleteConfirmationModal}
                          resetPasswordClick={this.props.resetPasswordClick}
                          loggedUserId={this.props.loggedUserId}
                          handleSaveClick={this.props.handleSaveClick}
                          activeTab={this.props.currentActiveTab}
                          userListPageSize={this.props.userListPageSize}
                          userListCurrentPageNo={this.props.userListCurrentPageNo}
                          usersList={this.props.usersList}
                          usersCount={this.props.usersCount}
                          getAllUserData={this.props.getAllUserData}
                          searchKey={this.state.searchKey}
                          isSSOEnabled={this.props.isSSOEnabled}
                          modules={this.props.modules}
                          initializeMfaClick={this.props.initializeMfaClick}
                        /> : null
                      }
                    </div>
                  </Col>
                </Row>
              </TabPane>
              <TabPane tabId="2">

                {!this.props.sessionDetails && !this.props.sessionKey ?
                  this.props.currentActiveTab === "2" ?
                    <SessionList
                      sessionsList={this.props.sessionsList}
                      sessionsCount={this.props.sessionsCount}
                      fetchSessionsList={this.props.fetchSessionsList}
                      sessionListCurrentPageNo={this.props.sessionListCurrentPageNo}
                      activeTab={this.props.currentActiveTab}
                      getSessionInvitiesAndSessionDetails={this.props.getSessionInvitiesAndSessionDetails}
                      language={this.props.language}
                      sessionListPageSize={this.props.sessionListPageSize}
                      searchKey={this.state.searchKey}
                    /> : null
                  :
                  this.props.sessionDetails &&
                  <SessionDetails
                    pdftronKey={this.props.pdftronKey}
                    sessionDetails={this.props.sessionDetails}
                    inviteesList={this.props.inviteesList}
                    onBackClick={this.props.onBackClick}
                    getSessionInvitiesAndSessionDetails={this.props.getSessionInvitiesAndSessionDetails}
                    sessionObjects={this.props.sessionObjects}
                    recordingObjects={this.props.recordingObjects}
                    showSpinner={this.props.showSpinner}
                    hideSpinner={this.props.hideSpinner}
                    language={this.props.language}
                  />
                }
              </TabPane>
              
              <TabPane tabId="3">
                {this.props.currentActiveTab === "3" ?
                  <SmsSentNumber
                    smsSentNumPageNo={this.props.smsSentNumPageNo}
                    activeTab={this.props.currentActiveTab}
                    getSessionInvitiesAndSessionDetails={this.props.getSessionInvitiesAndSessionDetails}
                    language={this.props.language}
                    searchKey={this.state.searchKey}
                    smsSendNumList={this.props.smsSendNumList}
                    smsSentNumber={this.props.smsSentNumber}
                  /> : null
                }
              </TabPane>
              <TabPane tabId="4">
                {this.props.currentActiveTab === "4" ?
                  <EncodingTime
                    activeTab={this.props.currentActiveTab}
                    getSessionInvitiesAndSessionDetails={this.props.getSessionInvitiesAndSessionDetails}
                    language={this.props.language}
                    searchKey={this.state.searchKey}
                    encodingTimeList={this.props.encodingTimeList}
                    encodingTime={this.props.encodingTime}
                  /> : null
                }
              </TabPane>
              <TabPane tabId="5">
                {this.props.currentActiveTab === "5" ?
                  <UsageReport
                    activeTab={this.props.currentActiveTab}
                    language={this.props.language}
                  /> : null
                }
              </TabPane>
            </TabContent>
          }
        </div>
      </div>
    );
  }
}

export default Users;
